import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=4ad7d97c&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ad7d97c')) {
      api.createRecord('4ad7d97c', component.options)
    } else {
      api.reload('4ad7d97c', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=4ad7d97c&", function () {
      api.rerender('4ad7d97c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2KeL37xhwSoQv/JS/imageCarousel.vue"
export default component.exports